<script>
import { mapActions, mapState } from 'vuex';
import NonDynamicTransportTripSeatings from './NonDynamicTransportTripSeatings';
import NonDynamicTransportTripConsumables from './NonDynamicTransportTripConsumables';
import NonDynamicTransportTripUpgradesRow from './NonDynamicTransportTripUpgradesRow';
import NonDynamicTransportTripUpgrades from './NonDynamicTransportTripUpgrades';

export default {
  name: 'NonDynamicTransportTripInformation',
  components: {
    NonDynamicTransportTripUpgrades,
    NonDynamicTransportTripSeatings,
    NonDynamicTransportTripConsumables,
    NonDynamicTransportTripUpgradesRow,
  },
  props: {
    tripId: {
      type: Number,
      default: null,
    },
    tripSeatingSectionTypes: {
      type: Array,
      required: true,
    },
    tripConsumableTypes: {
      type: Array,
      required: true,
    },
    tripUpgradeTypes: {
      type: Array,
      required: true,
    },
    defaultTripSeating: {
      type: Object,
      required: true,
    },
    defaultTripConsumables: {
      type: Object,
      required: true,
    },
    defaultTripUpgrade: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showInformationModal: false,
      localTripSeatings: [],
      localTripConsumables: [],
      localTripUpgrades: [],
      lastConsumableIndex: 0,
      lastUpgradeIndex: 0,
      consumablesTitle: this.$t('nonDynamicTransport.titles.consumable'),
    };
  },
  created() {
    if (this.tripId) {
      this.getTransportTripSeatingsByTripId(this.tripId);
      this.getTransportTripConsumablesByTripId(this.tripId);
      this.getTransportTripUpgradesByTripId(this.tripId);
    }
  },
  computed: {
    ...mapState({
      tripConsumables: state => state.nonDynamicTransport.tripConsumables.items,
      tripConsumablesLoading: state => state.nonDynamicTransport.tripConsumables.loading,
      tripSeatings: state => state.nonDynamicTransport.tripSeatings.items,
      tripSeatingsLoading: state => state.nonDynamicTransport.tripSeatings.loading,
      tripUpgrades: state => state.nonDynamicTransport.tripUpgrades.items,
      tripUpgradesLoading: state => state.nonDynamicTransport.tripUpgrades.loading,
    }),
  },
  methods: {
    ...mapActions({
      getTransportTripSeatingsByTripId: 'nonDynamicTransport/getTransportTripSeatingsByTripId',
      getTransportTripConsumablesByTripId: 'nonDynamicTransport/getTransportTripConsumablesByTripId',
      getTransportTripUpgradesByTripId: 'nonDynamicTransport/getTransportTripUpgradesByTripId',
    }),
  },
};
</script>

<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="showInformationModal"
      width="1200"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          color="success lighten-1"
          :disabled="!tripId"
          v-on="on"
        >
          {{ $t('buttons.seatingMealUpgrades') }}
        </v-btn>
      </template>

      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          {{ $t('nonDynamicTransport.titles.seatingMealUpgrades') }}
        </v-card-title>

        <non-dynamic-transport-trip-seatings
          :trip-id="tripId"
          :default-trip-seating="defaultTripSeating"
          :trip-seatings="tripSeatings"
          :trip-seating-section-types="tripSeatingSectionTypes"
          :trip-seatings-loading="tripSeatingsLoading"
        />

        <div class="divider" />

        <non-dynamic-transport-trip-consumables
          :trip-id="tripId"
          :default-trip-consumable="defaultTripConsumables"
          :trip-consumables="tripConsumables"
          :trip-consumable-types="tripConsumableTypes"
          :trip-consumables-loading="tripConsumablesLoading"
        />

        <div class="divider" />

        <non-dynamic-transport-trip-upgrades
          :trip-id="tripId"
          :default-trip-upgrade="defaultTripUpgrade"
          :trip-upgrades="tripUpgrades"
          :trip-upgrade-types="tripUpgradeTypes"
          :trip-upgrades-loading="tripUpgradesLoading"
        />

        <div class="divider--end" />

        <v-card-actions>
          <v-spacer/>
          <v-btn
            class="mt-2"
            color="primary"
            @click="showInformationModal = false"
          >
            {{ $t('buttons.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style lang="scss" scoped>
  @import '../../assets/scss/variables';

  /deep/ .v-btn .v-btn__content {
    font-size: $font-size-sm;
  }

  .divider {
    border: 1px solid $divider-grey-lighter;

    &--end {
      border: 1px solid $divider-grey-light;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/non-dynamic-transport/NonDynamicTransportTripInformation.vue